import {ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Component({
    selector: 'app-dialog-general',
    templateUrl: './dialog-general.component.html',
    styleUrls: ['./dialog-general.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogGeneralComponent {

    @Input() headerText = 'Confirm Action';
    @Input() bodyText = '';
    @Input() cancelButtonText = 'Cancel';
    @Input() confirmButtonText = 'Confirm';
    @Input() showCancelButton = true;
    @Input() danger = true;
    @Input() showReason: boolean;
    @Input() showPriceInput: boolean;

    suspendReason = '';
    suspensionHours = 0;
    packageType = '';
    priceInput: number;

    @Output() onDialogConfirm: EventEmitter<void> = new EventEmitter<void>();
    @Output() onDialogCancel: EventEmitter<void> = new EventEmitter<void>();
    @Output() changeSuspendReason = new EventEmitter<string>();
    @Output() changeSuspensionHours = new EventEmitter<number>();
    @Output() changePackageType = new EventEmitter<string>();
    @Output() changePrice = new EventEmitter<number>();

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: KeyboardEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.onCancelClick();
    }

    setReason(value: string) {
        this.suspendReason = value;
        this.changeSuspendReason.emit(this.suspendReason);
    }

    radioValueSuspensionHours(value: number) {
        this.suspensionHours = value;
        this.changeSuspensionHours.emit(this.suspensionHours);
    }

    radioPackageType(value: string) {
        this.packageType = value;
        this.changePackageType.emit(this.packageType);
    }

    setPrice(value: number) {
        this.priceInput = value;
        this.changePrice.emit(this.priceInput);
    }

    onConfirmClick() {
        this.onDialogConfirm.emit();
    }

    onCancelClick() {
        this.onDialogCancel.emit();
    }
}
